module.exports = __webpack_public_path__ + "static/media/coupon.72e03874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/promocode/coupon.svg
// module id = 1627
// module chunks = 103